export const removeSpaces = (value = '') => value.replace(/\s/g, '');

export const onlyNumbers = (value = '') => value.replace(/\D/g, '');

export const onlyAlphanumerics = (value = '') => value.replace(/\W/g, '');

export const removeSpecialCharacters = (value = '') => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const normalizedLowerCase = (value = '') => removeSpecialCharacters(value).toLowerCase();

export const fillableString = (value = '') => value.replace(/([ ().\-/#$]+)/gi, '');

export const valueOrEmptyString = (value = '') => {
  if (value === null || value === undefined) return '';
  return value;
};

export const regexWithAcents = (value = '') => {
  const letters = {
    a: 'aáàâåäã',
    c: 'cç',
    e: 'eééèêëėęē',
    i: 'iíìîïįī',
    o: 'oóòôöõō',
    u: 'uúùûüū',
  };

  const normalized = normalizedLowerCase(value);

  let output = '';

  Object.keys(letters).forEach((key: keyof typeof letters) => {
    const replace = `[${letters[key]}]`;
    const current = !!output ? output : normalized;
    output = current.replace(new RegExp(key, 'gi'), replace);
  });

  return new RegExp(`(${output.replace(/\\/g, '')})`, 'gi');
};

export const getNoOnlyWhiteSpaces = (value: string) => {
  if (!value) return '';
  return value
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+/g, '')
    .replace(/\s{2,}$/g, '');
};
